import React from "react";
import { connect } from "react-redux";

import { Redirect } from "react-router-dom";
import { Form, Input, Icon, message, Col, Button, AutoComplete } from "antd";
import { Parse } from "parse";

//antd
const FormItem = Form.Item;
const AutoCompleteOption = AutoComplete.Option;

class RegistrationForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    redirect: false
  };
  handleSubmit = e => {
    var ctx = this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        var user = new Parse.User();
        var ACL = new Parse.ACL();
        ACL.setPublicReadAccess(false);
        ACL.equals(user.id);
        user.set("username", values.emailSignup);
        user.set("email", values.emailSignup);
        user.set("password", values.passwordSignup);
        user.setACL(ACL);
        user.signUp(null, {
          success: function(user) {
            // Do stuff after successful login.

            var currentUser = Parse.User.current();
            var sessionToken = currentUser.getSessionToken();
            Parse.User.become(sessionToken).then(
              function(user) {
                // The current user is now set to user.
                message.success(`Bienvenue sur Urban Fitness !`);

                // redirect to the rest of the profileForm
                ctx.props.dispatchUser(user, sessionToken);
              },
              function(error) {
                // The token could not be validated.
                message.error(`Erreur ${error.code}`);
              }
            );
          },
          error: function(user, error) {
            // The login failed. Check error to see why.
            if (error.code === 101) {
              message.error(
                "Ton mot de passe ou ton adresse email est incorrecte"
              );
            } else if (error.code === 100) {
              message.error(
                "Impossible de se connecter aux serveurs de Urban Fitness"
              );
            } else if (error.code === 202) {
              message.error("Un compte lié à cette adresse email existe déjà");
            } else {
              message.error("Erreur: " + error.code + " " + error.message);
            }
          }
        });
      }
    });
  };
  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue("passwordSignup")) {
      callback("Les mots de passe ne correspondent pas");
    } else {
      callback();
    }
  };
  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };
  handleEmailChange = value => {
    let autoCompleteResult;
    if (!value || value.includes("@")) {
      autoCompleteResult = [];
    } else {
      autoCompleteResult = [
        "@gmail.com",
        "@hotmail.fr",
        "@hotmail.com",
        "@yahoo.fr"
      ].map(domain => `${value}${domain}`);
    }
    this.setState({ autoCompleteResult });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { autoCompleteResult } = this.state;

    const continueSignUp = this.props.user.redirectToSignUp;
    if (continueSignUp) {
      return <Redirect to="/signup" />;
    }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    };
    /*const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

*/
    const emailOptions = autoCompleteResult.map(email => (
      <AutoCompleteOption key={email}>{email}</AutoCompleteOption>
    ));

    return (
      <Col lg={{ offset: 4 }} md={{ offset: 4 }} sm={{ offset: 8 }}>
        <h3>Créer un compte</h3>
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout}>
            {getFieldDecorator("emailSignup", {
              rules: [
                {
                  type: "email",
                  message: "Ce format d'email n'est pas valide."
                },
                {
                  required: true,
                  message: "Veuillez indiquer votre adresse mail"
                }
              ]
            })(
              <AutoComplete
                dataSource={emailOptions}
                onChange={this.handleEmailChange}
              >
                <Input
                  prefix={
                    <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Votre adresse mail"
                />
              </AutoComplete>
            )}
          </FormItem>
          <FormItem {...formItemLayout}>
            {getFieldDecorator("passwordSignup", {
              rules: [
                {
                  required: true,
                  message: "Veuillez indiquer votre mot de passe"
                },
                {
                  validator: this.validateToNextPassword
                }
              ]
            })(
              <Input
                type="password"
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Votre mot de passe"
              />
            )}
          </FormItem>
          <FormItem {...formItemLayout}>
            {getFieldDecorator("confirm", {
              rules: [
                {
                  required: true,
                  message: "Veuillez confirmer votre mot de passe"
                },
                {
                  validator: this.compareToFirstPassword
                }
              ]
            })(
              <Input
                type="password"
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Confirmez votre mot de passe"
                onBlur={this.handleConfirmBlur}
              />
            )}
          </FormItem>
          <FormItem {...formItemLayout}>
            <Button
              style={{
                backgroundColor: "#00cccc",
                borderColor: "#00cccc",
                color: "#FFF"
              }}
              htmlType="submit"
              className="login-form-button"
            >{`S'enregistrer`}</Button>
          </FormItem>
        </Form>
      </Col>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    dispatchUser: (user, token) => {
      dispatch({ type: "USERS_REDIRECT_SIGNUP", user: user, token: token });
    }
  };
};

const WrappedRegistrationForm = Form.create()(RegistrationForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedRegistrationForm);
